

jQuery(document).ready(function () {
    // jQuery(".tooltip-custom").tooltip();

    jQuery('[data-toggle="tooltip"]').tooltip();
})